"use client";

import React, { useState, useEffect } from "react";
import Image from "next/image";
import CourseTab from "../search-input-pods/coursetab";
import UniversityTab from "../search-input-pods/universitytab";
import AdviceTab from "../search-input-pods/advicetab";
import PgsSearch from "./pgs-search";
import dynamic from "next/dynamic";
import SearchBar from "@packages/shared-components/skeleton/searchbar";
import Pgssearchskeleton from "@packages/shared-components/skeleton/pgssearchsk";
import { GA4DataLayer, GA4DataLayerFn } from "@packages/lib/utlils/helper-function";
import API_URL from "@packages/lib/server-actions/api-urls";
import optimizedSearch from "@packages/lib/server-actions/optimizedsearch";
import ClearingSearch from "../search-input-pods/ClearingSearch";
import {
  getProjectSpecificData,
  isPGS,
  isWhatuni,
} from "@packages/lib/utlils/commonFunction";
import { SearchTabIntNames } from "../search-utils/search.model";
import { DataLayerGA4AttrType, GA4EventAttrType } from "@packages/lib/types/datalayerGA";
import { getClearingAjax, getInYearAjax } from "../search-utils/search-api";
import { GAConstants } from "@packages/shared-components/services/constants";

const UcasComponent = dynamic(
  () =>
    import(
      "@packages/shared-components/common-utilities/popups/ucas-calculator/ucascomponent"
    ),
  { ssr: false }
);

interface SearchBoxProps {
  customGA?: GA4EventAttrType;
  universalSearchPanel: any[];
  parentPageName: any;
}

const SearchBox = ({
  customGA = {},
  universalSearchPanel,
  parentPageName,
}: SearchBoxProps) => {
  const [fetching, setFetching] = useState<boolean>(true);
  const [course_data, setCourseData] = useState<any>({});
  const [uni_data, setUniData] = useState<any>([]);
  const [clearingSubjects, setClearingSubjects] = useState<any>({});
  const [pgs_search_data, setPgssearchdata] = useState({});
  const [searchFormHandle, setsearchFormHandle] = useState({
    activeTab: universalSearchPanel?.[0]?.navName?.toLowerCase(),
    isCourseType: false,
    isSubjectClicked: false,
    isLocationClicked: false,
    isAdviceClicked: false,
    isUniversityClicked: false,
    courseType: { qualUrl: "degree", qualCode: "M", qualDesc: "Undergraduate" },
    university: "",
    subject: {},
    location: {},
    advice: "",
  });
  const [isUcasPopupOpen, SetIsUcasPopupOpen] = useState(false);
  const isClearingEnabled = !!universalSearchPanel
    ?.filter((item: any) => !!item)
    ?.find(
      (ele: any) => ele?.navName?.toLowerCase() === SearchTabIntNames.Clearing
    )?.navName;
  const searchTabClick = (tabName: string) => {
    setsearchFormHandle((preData) => ({ ...preData, activeTab: tabName }));
  };

  const ucasClick = () => {
    SetIsUcasPopupOpen(true);
    const body = document.body;
    body.classList.add("overflow-y-hidden");
    GA4DataLayer({
      event: GAConstants.track_event,
      event_name: "ucas_calculator_open",
      click_text:"calculate_your_ucas_points",
      ...customGA,
    });
  };

  const ucasClose = () => {
    const body = document.body;
    SetIsUcasPopupOpen(false);
    body.classList.remove("overflow-y-hidden");
  };

  // ===========================initial fetch=============================================================================================
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [inYearSubjects, clearingOrInYearUni, clearingSubjects] =
          await Promise.all([
            getInYearAjax("SUBJECT", isClearingEnabled),
            getInYearAjax("INSTITUTION", isClearingEnabled),
            isClearingEnabled
              ? getClearingAjax()
              : { clearingSubjectList: [], locationList: [] },
          ]);
        setCourseData(inYearSubjects);
        setUniData(clearingOrInYearUni?.length ? clearingOrInYearUni : []);
        setClearingSubjects(
          clearingSubjects ?? { clearingSubjectList: [], locationList: [] }
        );
        setFetching(false);
      } catch (error) {
        setFetching(false);
        console.error("Error fetching data:", error);
      }
    };

    const fetchPgsData = async () => {
      const pgsbody: any = {
        affiliateId: process.env.AFFILATE_ID,
        actionType: "subject",
        keyword: "",
        qualCode: "",
        networkId: 2,
      };
      const queryParamspgsbody = new URLSearchParams(pgsbody).toString();

      try {
        const pgsdata = await optimizedSearch(
          process.env.NEXT_PUBLIC_BFF_API_DOMAIN + API_URL?.subjectAjax,
          "GET",
          null,
          queryParamspgsbody,
          null
        );

        setPgssearchdata(pgsdata);
        setFetching(false);
      } catch (error) {
        setFetching(false);
        console.error("Error fetching data:", error);
      }
    };

    if (
      !(Object.keys(uni_data)?.length > 0) &&
      !(Object.keys(course_data)?.length > 0) &&
      process.env.PROJECT == "Whatuni"
    ) {
      fetchData();
    } else {
      fetchPgsData();
    }
  }, []);

  const getCommonSearchBarGA = (): GA4EventAttrType => {
    let galogs = {
      event: GAConstants.track_event,
      event_name : "search_event"
    };
    if (parentPageName?.toLowerCase() === "clearing") {
      galogs = { ...galogs };
    }

    return { ...galogs, ...customGA };
  };

    const getCommonSearchBarOldGA = (): DataLayerGA4AttrType => {
    let galogs = {
      event: "ga_events",
      data_label: "clearing_subject_search",
      clearing: "in_year",
      page_name: localStorage.getItem("gaPageName") ?? "",
    };
    if (parentPageName?.toLowerCase() === "clearing") {
      galogs = { ...galogs , clearing: "clearing"};
    }

    return { ...galogs, ...customGA };
  };

  return (
    <>
      {/* WHATUNI SEARCH */}
      {isWhatuni() &&
        (fetching ? (
          <SearchBar parentPageName={parentPageName} />
        ) : (
          <div
            className={`xl:px-0 ${parentPageName === "Home" ? "md:px-[16px]" : "px-[0]"}`}
          >
            <div
              className={`bg-white w-full rounded-none max-w-container mx-auto p-[16px] mt-0 min-h-[160px] relative z-3 md:shadow-custom-5 md:rounded-[32px] md:p-[24px] ${parentPageName === "Home" ? "md:mt-[-82px]" : "m-[0]"}`}
            >
              <div className="grid grid-cols-1 md:grid-cols-2">
                {/* Seatrch Tabs */}
                <div className="flex gap-[8px] justify-center md:justify-start">
                  {universalSearchPanel?.map((items: any, index: number) => (
                    <button
                      key={index + 1}
                      data-text-id={`search_tab_${items?.navName?.toLowerCase()}_button`}
                      className={`rounded-[20px] px-[12px] py-[8px] small font-semibold inline-block border border-neutral-900 hover:bg-neutral-900 hover:text-white cursor-pointer ${
                        searchFormHandle?.activeTab ===
                        items?.navName?.toLowerCase()
                          ? "bg-neutral-900 text-white"
                          : "bg-white text-neutral-900"
                      }`}
                      onClick={() =>
                        searchTabClick(items?.navName?.toLowerCase())
                      }
                    >
                      {items?.navTitle}
                    </button>
                  ))}
                </div>
                {/* Seatrch Tabs */}

                {/* Seatrch Top Right Tool */}
                <div className="flex justify-center md:justify-end my-[24px] md:my-0">
                  {(() => {
                    switch (searchFormHandle?.activeTab?.toLocaleLowerCase()) {
                      case SearchTabIntNames.Clearing:
                      case SearchTabIntNames.Course:
                        return (
                          <>
                            <button
                              onClick={ucasClick}
                              data-text-id="ucas_calculator_button"
                              className="flex items-center gap-[6px] text-primary-400 font-semibold small cursor-pointer hover:underline"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.66678 6.11111H12.3334M12.3334 13.8889V11.5556M10.0001 13.8889H10.0079M7.66678 13.8889H7.67456M7.66678 11.5556H7.67456M10.0001 11.5556H10.0079M12.3334 9.22222H12.3412M10.0001 9.22222H10.0079M7.66678 9.22222H7.67456M6.11122 17H13.889C14.7481 17 15.4446 16.3036 15.4446 15.4444V4.55556C15.4446 3.69645 14.7481 3 13.889 3H6.11122C5.25211 3 4.55566 3.69645 4.55566 4.55556V15.4444C4.55566 16.3036 5.25211 17 6.11122 17Z"
                                  stroke="#4664DC"
                                  strokeWidth="1.67"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              Calculate your UCAS points
                            </button>
                            {isUcasPopupOpen && (
                              <UcasComponent
                                onClose={ucasClose}
                                isUcasOpen={isUcasPopupOpen}
                              />
                            )}
                          </>
                        );
                      case SearchTabIntNames.Uni:
                        return (
                          <a
                            href="/degrees/find-university/"
                            data-text-id="browse_unis_az_link"
                            className="flex items-center gap-[6px] text-primary-400 font-semibold small hover:underline"
                            onClick={async () => {
                              GA4DataLayer({
                                event: GAConstants.track_event,
                                event_name:"redirection_link_click",
                               // data_label: `${isClearingEnabled ? "clearing_" : ""}university_search`,
                                click_text: "Browse unis",
                                ...getCommonSearchBarGA(),
                              });
                            }}
                          >
                            Browse unis A-Z
                            <Image
                              src="/static/assets/icons/arrow-right.svg"
                              width={20}
                              height={20}
                              alt="Right Arrow"
                            />
                          </a>
                        );
                      case SearchTabIntNames.Advice:
                        return (
                          <a
                            href="/advice/"
                            data-text-id="browse_advice_link"
                            className="flex items-center gap-[6px] text-primary-400 font-semibold small hover:underline"
                            onClick={async () => {
                              GA4DataLayerFn({
                                event: "ga_events",
                                data_label: "advice_search",
                                data_label2: "view_all_clicks",
                                ...getCommonSearchBarGA(),
                              });
                            }}
                          >
                            Browse advice
                            <Image
                              src="/static/assets/icons/arrow-right.svg"
                              width={20}
                              height={20}
                              alt="Right Arrow"
                            />
                          </a>
                        );
                      default:
                        return null;
                    }
                  })()}
                </div>
                {/* Seatrch Top Right Tool */}

                {/* Seatrch Bars */}
                <div className="row-start-2 md:col-span-2 mt-[16px]">
                  {(() => {
                    switch (searchFormHandle?.activeTab?.toLocaleLowerCase()) {
                      case SearchTabIntNames.Clearing:
                        return (
                          <ClearingSearch
                            customGA={getCommonSearchBarGA()}
                            placeholder={universalSearchPanel[0]?.navCtAlabel}
                            clearingCourseList={
                              clearingSubjects?.clearingSubjectList
                            }
                            locationList={clearingSubjects?.locationList}
                            customOldGA={getCommonSearchBarOldGA()}
                          />
                        );
                      case SearchTabIntNames.Course:
                        return (
                          <CourseTab
                            customGA={getCommonSearchBarGA()}
                            placeholder={universalSearchPanel[0]?.navCtAlabel}
                            searchFormHandle={searchFormHandle}
                            setsearchFormHandle={setsearchFormHandle}
                            data={course_data}
                            showlocation={true}
                            
                          />
                        );
                      case SearchTabIntNames.Uni:
                        return (
                          <UniversityTab
                            customGA={getCommonSearchBarGA()}
                            placeholder={universalSearchPanel[2]?.navCtAlabel}
                            searchFormHandle={searchFormHandle}
                            setsearchFormHandle={setsearchFormHandle}
                            data={uni_data}
                            isClearingEnabled={isClearingEnabled}
                          />
                        );
                      case SearchTabIntNames.Advice:
                        return (
                          <AdviceTab
                            customGA={getCommonSearchBarGA()}
                            placeholder={universalSearchPanel[3]?.navCtAlabel}
                            searchFormHandle={searchFormHandle}
                            setsearchFormHandle={setsearchFormHandle}
                          />
                        );
                      default:
                        return null;
                    }
                  })()}
                </div>
                {/* Seatrch Bars */}
              </div>
              <div className="flex items-start justify-center gap-[8px] md:hidden">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.5 15.6H17V14.2C17 13.0402 16.0598 12.1 14.9 12.1C14.2311 12.1 13.6352 12.4128 13.2506 12.9M13.5 15.6H6.5M13.5 15.6V14.2C13.5 13.7407 13.4115 13.302 13.2506 12.9M6.5 15.6H3V14.2C3 13.0402 3.9402 12.1 5.1 12.1C5.76892 12.1 6.3648 12.4128 6.74937 12.9M6.5 15.6V14.2C6.5 13.7407 6.5885 13.302 6.74937 12.9M6.74937 12.9C7.26545 11.6107 8.52637 10.7 10 10.7C11.4736 10.7 12.7345 11.6107 13.2506 12.9M12.1 6.50002C12.1 7.65982 11.1598 8.60002 10 8.60002C8.8402 8.60002 7.9 7.65982 7.9 6.50002C7.9 5.34023 8.8402 4.40002 10 4.40002C11.1598 4.40002 12.1 5.34023 12.1 6.50002ZM16.3 8.60002C16.3 9.37322 15.6732 10 14.9 10C14.1268 10 13.5 9.37322 13.5 8.60002C13.5 7.82683 14.1268 7.20002 14.9 7.20002C15.6732 7.20002 16.3 7.82683 16.3 8.60002ZM6.5 8.60002C6.5 9.37322 5.8732 10 5.1 10C4.3268 10 3.7 9.37322 3.7 8.60002C3.7 7.82683 4.3268 7.20002 5.1 7.20002C5.8732 7.20002 6.5 7.82683 6.5 8.60002Z"
                    stroke="#333333"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="x-small">
                  More than
                  <span className="font-semibold"> 5 million people </span> come
                  to Whatuni each year for their university research
                </div>
              </div>
            </div>
          </div>
        ))}
      {/* WHATUNI SEARCH */}

      {/* PGS SEARCH */}
      {isPGS() && (
        <div className="max-w-container mx-auto">
          <div className="px-[16px] py-[16px] xl:p-0 flex flex-col gap-[16px]">
            <div className="relative z-3 md:mt-[-28px] ">
              {fetching ? (
                <Pgssearchskeleton />
              ) : (
                <PgsSearch pgs_search_data={pgs_search_data} />
              )}
            </div>
          </div>
        </div>
      )}
      {/* PGS SEARCH */}
    </>
  );
};

export default SearchBox;
